import * as React from 'react';
export const IcSignOut = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.9 11.61a.867.867 0 00-.22-.32l-3-3A1 1 0 0018 8a1 1 0 00-.38.08A1.002 1.002 0 0017 9c.007.264.11.517.29.71L18.56 11H10a1 1 0 00-.92.62 1 1 0 00-.006.764c.05.122.123.233.216.326A1 1 0 0010 13h8.59l-1.31 1.29c-.09.092-.161.201-.21.32A1 1 0 0017 15c.002.13.029.26.08.38.048.123.119.235.21.33.097.091.209.166.33.22A1 1 0 0018 16a1 1 0 00.39-.07.87.87 0 00.32-.22l3-3a.829.829 0 00.22-.33A.998.998 0 0022 12a1.088 1.088 0 00-.1-.39zm-3.71 6.56a1 1 0 00-.61-.17 1 1 0 00-.63.23 7.54 7.54 0 01-2.5 1.37 8.001 8.001 0 01-3.73.31 8.12 8.12 0 01-3.46-1.43A8 8 0 014.83 8.36a8 8 0 019.62-4A7.68 7.68 0 0117 5.77a1 1 0 00.6.23.92.92 0 00.58-.17 1 1 0 00.38-.47 1.06 1.06 0 000-.61 1 1 0 00-.32-.51 9.519 9.519 0 00-2.1-1.32 10 10 0 102.06 16.89.91.91 0 00.37-.51 1 1 0 000-.63.999.999 0 00-.38-.5z'
      fill='currentColor'
    />
  </svg>
);
